export const projectsDetailsData = {
	"ripple-social": {
		title: "Ripple Social",
		description:
			"Ripple is a social media app that helps you connect and share your work with friends and connections. Below are the key features of the app.",
		techStack: [
			"ReactJS",
			"Redux Toolkit",
			"Firebase",
			"React Router v6",
			"HTML",
			"CSS",
			"RippleUI",
		],
		githubURL: "https://github.com/sonishreyas/ripple-social",
		liveURL: "https://ripple-social.netlify.app/",
		demoURL: "https://www.loom.com/embed/a5c3adf16f454a8ca448488519f93847",
		features: [
			"Infinite Scroll",
			"Debounce Search",
			"Shimmering",
			"Create Posts (image, video, gif, document, and emojis)",
			"Edit and Delete Posts",
			"User Feed",
			"Explore Page",
			"User Profile Page (Edit Profile, Posts)",
			"User Profile and background Picture",
			"Follow/Unfollow other users",
			"Authentication (Signup, Login, and Logout)",
			"Bookmark Posts",
			"Like Posts",
			"Comments",
			"Suggested users",
			"Sort Posts",
			"All the pages and components are responsive",
			"All the components support both dark and light theme",
		],
	},
	"ripple-store": {
		title: "Ripple Store",
		description:
			"Ripple Store is an e-commerce website to buy the best footwear. Below are the key features of the app.",
		techStack: [
			"ReactJS",
			"React Context API + useReducers",
			"Razorpay API",
			"React Router v6",
			"HTML",
			"CSS",
			"RippleUI",
			"Mockbee (MirageJS-based APIs)",
		],
		githubURL: "https://github.com/sonishreyas/ripple-store-app",
		liveURL: "https://ripple-store-app.netlify.app/",
		demoURL: "https://www.loom.com/embed/a5c3adf16f454a8ca448488519f93847",
		features: [
			"Pagination on product listing page",
			"Payment integration using razorpay API",
			"Debounce in search functionality",
			"Home page",
			"Product listing page",
			"Filters by price range slider, category, and rating range slider",
			"SortBy price, rating, and discount",
			"Cart Management",
			"Wishlist Management",
			"Authentication (Signup, Login, and Logout)",
			"Address Management (add, edit and delete address)",
			"User Profile Page",
			"Order Summary",
			"Checkout",
			"All the pages and components are responsive",
			"All the components support both dark and light theme",
		],
	},
	"ripple-play": {
		title: "Ripple Play",
		description:
			"Ripple Play is a video library app where user can watch the video content available. Below are the key features of the app.",
		techStack: [
			"ReactJS",
			"React Context API + useReducers",
			"React Router v6",
			"HTML",
			"CSS",
			"RippleUI",
			"Mockbee (MirageJS-based APIs)",
		],
		githubURL: "https://github.com/sonishreyas/ripple-video-library",
		liveURL: "https://ripple-video-library.netlify.app/",
		demoURL: "https://www.loom.com/embed/a5c3adf16f454a8ca448488519f93847",
		features: [
			"Infinite Scroll",
			"Debounce Search",
			"Shimmering",
			"Home page",
			"Filters by category",
			"Watchlater Management",
			"Watch History Management",
			"Clear and Pause History",
			"Authentication (Signup, Login, and Logout)",
			"Like Management",
			"Single Video Page",
			"Comments on videos",
			"Forget Password",
			"User Profile Page",
			"Playlist Management",
			"Similar videos",
			"All the pages and components are responsive",
			"All the components support both dark and light theme",
		],
	},
	"ripple-quiz": {
		title: "Ripple Quiz",
		description:
			"Ripple Quiz is a fun app where you can play different quiz based on your choice. Below are the key features of the app.",
		techStack: [
			"TypeScript",
			"ReactJS",
			"React Context API + useReducers",
			"React Router v6",
			"HTML",
			"CSS",
			"RippleUI",
			"Mockbee (MirageJS-based APIs)",
		],
		githubURL: "https://github.com/sonishreyas/ripple-quiz-app",
		liveURL: "https://ripple-quiz-app.netlify.app/",
		demoURL: "https://www.loom.com/embed/a5c3adf16f454a8ca448488519f93847",
		features: [
			"Debounce Search",
			"Shimmering",
			"Home Page",
			"Quiz By Category Page",
			"Search feature for quiz",
			"User Profile Page",
			"Avatar for users",
			"Authentication (Signup, Login, and Logout)",
			"Rules Page",
			"Quiz MCQ Page",
			"Results Page",
			"Quit Quiz",
			"All the pages and components are responsive",
			"All the components support both dark and light theme",
		],
	},
	"ripple-ui": {
		title: "Ripple UI",
		description:
			"Ripple UI is a minimal, customizable, and user friendly component library built using HTML, CSS, and Javascript. Below are the key features of the app.",
		techStack: ["HTML", "CSS", "JavaScript"],
		githubURL: "https://github.com/sonishreyas/ripple-ui",
		liveURL: "https://ripple-ui.netlify.app/",
		demoURL: "https://www.loom.com/embed/a5c3adf16f454a8ca448488519f93847",
		features: [
			"Alerts",
			"Avatars",
			"Badges",
			"Buttons",
			"Cards",
			"Chips",
			"Drawers",
			"Grids",
			"Images",
			"Inputs",
			"Lists",
			"Modals",
			"Navigation",
			"Rating",
			"Slider",
			"Snackbars",
			"Typography",
			"Tabs",
			"All the pages and components are responsive",
			"All the components support both dark and light theme",
		],
	},
};
